import { idb } from "../../root/idb";
import { incomingMessagesTypes } from "../../root/modules/incoming-messages/data/incoming-messages-types";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log";
import { useMainStore } from "../store/mainStore";

const setAlertAsDismissedLog = log(loggingContexts.setAlertAsDismissed);

export const setAlertAsDismissed = async ({ message }) => {
  const {
    message: { alertID, caseID, group },
  } = message;
  const mainStore = useMainStore();

  const groupMatches = group === mainStore.group && !!mainStore.group;

  if (groupMatches) {
    setAlertAsDismissedLog.info(
      "group matches",
      groupMatches,
      group,
      mainStore.group
    );

    setAlertAsDismissedLog.info("alertID to close", { alertID });
    setAlertAsDismissedLog.info("caseID to close", { caseID });

    const connection = await idb();

    let cursor = await connection
      .transaction("incomingMessages", "readwrite")
      .store.index("timestamp")
      .openCursor(undefined, "prev");

    let count = 0;
    let found = false;

    while (cursor) {
      count += 1;

      if (count > 2000) {
        await cursor.delete();
      } else {
        let { value: incomingMessage } = cursor;

        if (
          incomingMessage.id === alertID &&
          incomingMessage.type === incomingMessagesTypes.Alert &&
          incomingMessage.dismissed === false
        ) {
          incomingMessage.dismissed = true;

          setAlertAsDismissedLog.info(
            "alert to close found",
            alertID,
            caseID,
            incomingMessage
          );

          await cursor.update(incomingMessage);

          found = true;
        }

        if (
          found === true &&
          incomingMessage.caseID === caseID &&
          incomingMessage.id !== alertID &&
          incomingMessage.type === incomingMessagesTypes.Alert &&
          incomingMessage.dismissed === false
        ) {
          incomingMessage.dismissed = true;

          setAlertAsDismissedLog.info(
            "previously received alert found",
            alertID,
            caseID,
            incomingMessage
          );

          await cursor.update(incomingMessage);
        }

        if (
          incomingMessage.type ===
          incomingMessagesTypes.ConnectivityCheckToMessagingServers
        ) {
          await cursor.delete();
        }
      }

      cursor = await cursor.continue();
    }
  }
};
